import { useEffect, useState } from 'react';

interface Props {
  delay?: number;
  enabled?: boolean;
}

interface ReturnProps {
  isScrolling: boolean;
  canScrollVertically: boolean;
  hasVerticalScrolling: boolean;
}

const useScrollDetection = ({ delay = 200, enabled = true }: Props): ReturnProps => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    let timeoutId: NodeJS.Timeout;

    const handleScroll = () => {
      setIsScrolling(true);

      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        setIsScrolling(false);
      }, delay);
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);

      return () => {
        window.removeEventListener('scroll', handleScroll);
        clearTimeout(timeoutId);
      };
    }
  }, [enabled, delay]);

  if (typeof window !== 'undefined') {
    const hasVerticalScrolling = window.document.body.scrollHeight > window.innerHeight;
    const canScrollVertically =
      hasVerticalScrolling && window.scrollY + window.innerHeight + 10 < window.document.body.scrollHeight;
    return { isScrolling, hasVerticalScrolling, canScrollVertically };
  }

  return { isScrolling, hasVerticalScrolling: false, canScrollVertically: false };
};

export default useScrollDetection;
